import { getCurrentMonthString } from "@/lib/date.utils";
import { parseAsString, useQueryState } from "nuqs";

/**
 * Billing-month URL state, shared by all tabs on the credit-cards page.
 * Semantics: "2026-09" = statements generated in Sep 2026 (per-card windows
 * derive from each account's statementDayOfMonth).
 */
export function useBillingMonth() {
  return useQueryState("month", parseAsString.withDefault(getCurrentMonthString()));
}
